import { AttributesFields } from "./Fields";

const PATHS = {
  DASHBOARD: `/dashboard`,
  SETTING: `/settings`,
  LOGIN: `/auth/login`,
  REGISTER: `/auth/register`,
  RESET_PASSWORD: `/auth/reset-password`,
  FORGOT_PASSWORD: `/auth/forgot-password`,
  ACCOUNT: `/account`,
  USER_LIST: "/user-list",
  ADD_USER: "/add-user",
  ALL_PRODUCT: "/all-product",
  IMPORT_PRODUCT: "/import-product",
  WINE_DATA_SET: "/wine-dataset/view",

  WINE_DATASET_UNAPPROVED_LIST: "/wine-dataset/unapproved",
  WINE_DATASET_UNAPPROVED_VIEW: "/wine-dataset/unapproved/view",
  WINE_DATASET_UNAPPROVED_EDIT: "/wine-dataset/unapproved/edit",
};
export default PATHS;
